import React, { useEffect, useMemo, useState } from 'react'
import BeneficiaryContainer from '../BeneficiaryContainer'
import classes from './BeneficiaryCourses.module.css'
import { getImageURL, getNumMatches } from '../../../util/functions'
import ToggleBar from '../../../components/ToggleBar/ToggleBar'
import { ProgressSummaryCard } from '../../../components/Cards/ProgressSummaryCard/ProgressSummaryCard'
import emptyIcon from '../../../assets/images/beneficiary-my-courses-empty-state.svg'
import coursePlaceholder from '../../../assets/images/course-placeholder.svg'
import { useDispatch, useSelector } from 'react-redux'
import { getBeneficiaryCourses } from './beneficiaryCoursesApi'
import { userSelectors } from '../../../redux/userSlice'
import { beneficiaryCoursesSelectors } from './beneficiaryCoursesSlice'
import CardLoader from '../../../components/loaders/CardLoader'
import Empty from '../../../components/Empty/Empty'
import { HeaderSearch } from '../../../components/Header/Header'
import { getUserCourses } from '../../Course/userCoursesApi'
import { userCoursesSelectors } from '../../Course/userCoursesSlice'

const filters = {
    ongoing: c => c.percentageProgress < 100,
    completed: c => c.percentageProgress === 100,
}

const BeneficiaryCourses = ({ location }) => {
    const { pathname: path } = location

    const [activeToggleItem, setActiveToggleItem] = useState('all')

    // const courses = useSelector(beneficiaryCoursesSelectors.courses)
    // const isFetching = useSelector(beneficiaryCoursesSelectors.isFetching)
    const isFetching = useSelector(userCoursesSelectors.isFetching)
    const coursesStore = useSelector(userCoursesSelectors.courses)

    const toggleItems = useMemo(
        () => [
            {
                text: 'All',
                id: 'all',
            },
            {
                text: 'Ongoing',
                badge: activeToggleItem === 'ongoing' && {
                    variant: 'blue',
                    text: coursesStore.length,
                },
                id: 'ongoing',
            },
            {
                text: 'Completed',
                id: 'completed',
            },
        ],
        [activeToggleItem, coursesStore]
    )

    const [search, setSearch] = useState('')

    const validCourses = useMemo(() => {
        let filteredCourses = coursesStore.filter(({ title }) =>
            new RegExp(search, 'i').test(title)
        )
        return filteredCourses
    }, [activeToggleItem, coursesStore, search])

    const dispatch = useDispatch()

    const user = useSelector(userSelectors.userDetails)

    useEffect(() => {
        dispatch(
            getUserCourses({
                queryParam:
                    activeToggleItem === 'all' ? undefined : activeToggleItem,
            })
        )
    }, [user.email, dispatch, activeToggleItem])

    return (
        <BeneficiaryContainer>
            <div className={classes.topBar}>
                <h1 className={classes.topBarTitle}>My Courses</h1>
                <HeaderSearch
                    className={classes.topSearch}
                    value={search}
                    onChange={setSearch}
                />
                <ToggleBar
                    links={toggleItems}
                    changeActive={setActiveToggleItem}
                    activeId={activeToggleItem}
                />
            </div>
            <div className={classes.courses}>
                {isFetching
                    ? [...Array(6)].map((_, idx) => <CardLoader key={idx} />)
                    : validCourses.map(
                          (
                              {
                                  title,
                                  catName,
                                  thumbnail,
                                  progressDetails,
                                  coursecode,
                                  classid,
                                  currentLessonId,
                                  currentTopicId,
                              },
                              index
                          ) => (
                              <ProgressSummaryCard
                                  to={`${path}/${coursecode}/${classid}/lessons/${currentLessonId}/${currentTopicId}`}
                                  title={title}
                                  category={catName}
                                  image={
                                      thumbnail
                                          ? getImageURL(thumbnail)
                                          : coursePlaceholder
                                  }
                                  progress={progressDetails.percentageCompleted}
                                  key={index}
                                  vertical
                                  className={classes.card}
                              />
                          )
                      )}
            </div>
            {!isFetching && validCourses.length === 0 && (
                <Empty icon={emptyIcon} text={'No Courses Found'} />
            )}
        </BeneficiaryContainer>
    )
}

export default BeneficiaryCourses
